import { Directive, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
declare var $: any; // TODO show modal in othe way
import { environment } from "@environments/environment";
import { HttpClient } from '@angular/common/http';


// Translate
import { TranslateService } from '@ngx-translate/core';

// App Constants
import { AppConstants } from '@app/appConstants';

// Services
import {
  ResourceService,
  UserService,
  CalendarLanguagueService
} from "@services/index.service";

// Interfaces
import { SearchtermsInterface, ResponseDataBase } from '@interfaces/index.interface';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatabaseResourcesService } from '../../services/database-resources/database-resources.service';

/** Página de entrada a la aplicación */
@Directive({})
export class BookappointmentsBase implements AfterViewInit {

  @ViewChild('calendar', null) calendar;
  environmentName = environment.envName;
  formaPass: FormGroup;
  patient;
  freeslots;
  /**La configuración actual necesita convertir los freeslots que devuelve el back a este formato */
  tableSlots;
  /** Son los slots del único día que mostramos */
  daySlots;
  /** Guardamos tanto el día que estmos mostrando como el día que nos ha mandado el back */
  firstDayReturned;
  firstDayReturnedShowed;
  daySearched;
  daySearchedtoCompare;
  minDate: NgbDate = new NgbDate(moment().year(), moment().month() + 1, moment().date() + 1);
  tomorrow;
  stringTomorrow;
  loading: string = 'LOADING';
  /** Cogemos el nombre de la aseguradora para mostrarla en el modal */
  selectedPayorName;
  isForDependents: boolean = false;
  dependentId;
  alert: string;
  /**Valores extraidos del environment para saber las propiedades del sitio a construir */
  hasSubdepartmentSearch = environment.OPTIONAL_FIELDS_FOR_BOOKAPPOINTMENTS.SUBDEPARTMENT;
  hasTimeframe = environment.OPTIONAL_FIELDS_FOR_BOOKAPPOINTMENTS.TIMEFRAME;
  hasCookieBar = environment.HASCOOKIEBAR;
  hasVideoCall = environment.VIDEOCALL.HAS;
  hasMyDepents = environment.HASMYDEPENTS;
  privacyPolicy;
  explorerDateVariable;

  /** Términos de búsqueda que usaremos para buscar huecos */
  searchterms: SearchtermsInterface = {
    hospitalId: null,
    payorId: null,
    departmentId: null,
    treatmentId: null,
    doctorId: null,
    date: null,
    timeframeId: null,
    visitTypeId: null,
    buildingUnitId: null
  };

  constructor(public router: Router,
    public _resourceService: ResourceService,
    public translate: TranslateService,
    public _userService: UserService,
    public http: HttpClient, public _databaseResourcesService: DatabaseResourcesService,
    public locale: CalendarLanguagueService) {
    // Sólo typet usa el antiguo formato de fecha
    /* if (this.environmentName == 'typet') {
      this.tomorrow = moment().add(1, 'days').format('DD-MM-YYYY');
      this.stringTomorrow = moment().add(1, 'days').format('DD-MM-YYYY');
    } else { */
    this.tomorrow = moment().add(1, 'days').toDate();
    this.stringTomorrow = moment().add(1, 'days').format('DD-MM-YYYY');
    // }
    /** Configuramos la página para comenzar. Si el entorno esta configurado para mostrar el aviso de cookies preguntamos
     * si ya ha dado su consentimiento y si no mostramos barra de consentimiento. Eliminamos las alertas. Rellenamos el día 
     * de búsqueda con 'mañana' y si hay configurados más de un hospital ponemos un array de departamentos vacio a la espera
     * de que se rellene cuando se seleccione un hospital
     */
    this.formaPass = new FormGroup({
      "password": new FormControl("", [
        Validators.required
      ]),
      "confirmpassword": new FormControl("", [
        Validators.required
      ]),
    });
    this.formaPass.controls["confirmpassword"].setValidators([
      this.notEqualPassword.bind(this.formaPass)
    ]);

    if (this.hasCookieBar) {
      this.hasCookieBar = !window.document.cookie.includes('cookieLawSeen');
    }
    if (this._resourceService.alert == 'LOGOUT_FOR_INACTIVITY') {
      this._userService.warning = 'LOGOUT_FOR_INACTIVITY';
    }
    delete this._resourceService.alert;
    this.searchterms.date = this.tomorrow;
    if (this._resourceService.hospitals.length > 1) {
      this._resourceService.departments = [];
    }
    if (this._resourceService.payors.length == 1) {
      this.searchterms.payorId = this._resourceService.payors[0].id;
    }
  }

  /** Comprueba que las passwords a modificar sean iguales */
  notEqualPassword(control: FormControl): { [s: string]: boolean } {
    const forma: any = this;
    if (control.value !== forma.controls["password"].value) {
      return {
        notEqualsPass: true
      };
    }
    return null;
  }

  /** Manda al back la petición de cambio del password */
  changePass() {
    let params = {
      password: this.formaPass.controls.password.value
    };
    this._userService.changeUserPass(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        // this.alert = 'You have been successfully change your password';
        this._userService.user.passInitial = false;
        sessionStorage.setItem('dataPatient', JSON.stringify(this._userService.user));
        window.scrollTo(0, 0);
        if (this._userService.user.role == 'admin' || this._userService.user.role == 'superadmin') {
          this.router.navigate(['/admin/user-management']);
        } else if (this._userService.user.role == 'consultant') {
          this.router.navigate(['/admin/database-resources/consultants/edit-consultant']);
        }
      } else {
        // this.alert = 'Your password could not be changed';
        window.scrollTo(0, 0);
      }
      this._userService.loading = false;
    });
  }

  /** Antes de lanzar la búsqueda de huecos comprobamos que tenemos los datos necesarios */
  checkSearchTerms() {
    delete this._resourceService.alert;
    delete this.daySlots;
    let selectedPayor = this._resourceService.payors.filter(obj => {
      return obj.id === this.searchterms.payorId
    })
    if (selectedPayor[0]) {
      this.selectedPayorName = selectedPayor[0].name;
    }
    if (this._resourceService.hospitals.length == 1) {
      this.searchterms.hospitalId = this._resourceService.hospitals[0].id
    }
    if (!this.searchterms.hospitalId) {
      this._resourceService.alert = "PLEASE_SELECT_AN_HOSPITAL";
    } else {
      // Typet sigue utilizando el formato de fecha antiguo
      /* if (this.environmentName != 'typet') {
        if (!this.searchterms.date) {
          this._resourceService.alert = "PLEASE_SELECT_VALID_DATE_CAN_USE_CALENDAR";
        } else {
          if (this.searchterms.departmentId && this.searchterms.payorId) {
            this.searchFreeSlots();
          } else {
            this._resourceService.alert = "PLEASE_SELECT_DEPARTMENT_AND_PAYOR";
          }
        }
      } else { */
      if (typeof (this.searchterms.date) == 'string' && moment(this.searchterms.date, "DD-MM-YYYY").format('YYYY-MM-DD') == 'Invalid date') {
        this._resourceService.alert = "PLEASE_SELECT_VALID_DATE_CAN_USE_CALENDAR";
      } else {
        if (this.searchterms.departmentId && this.searchterms.payorId) {
          this.searchFreeSlots();
        } else {
          this._resourceService.alert = "PLEASE_SELECT_DEPARTMENT_AND_PAYOR";
        }
      }

      //  }

    }
  }

  showCalendar() {
    this.calendar.showOverlay();
  }

  /** Lanzamos la búsquedaq de huecos al back eliminando los términos que nos se han rellenado
   * Si el back devuelve error lo mostramos, sino rellenamos con lo que nos envia las propiedades necesarias.
   */
  searchFreeSlots() {
    //explorer 11 elimina la variable date del context y la leo y elimino si vengo del getNextDay() o getPreviousDay()
    if (this.explorerDateVariable) {
      this.searchterms.date = this.explorerDateVariable;
      delete this.explorerDateVariable;
    }
    let formatedDate;
    /* if (this.environmentName == 'typet') {
      formatedDate = this._resourceService.formatDate(this.searchterms.date);
    } else { */

    formatedDate = moment(this.searchterms.date, "DD-MM-YYYY").format('YYYY-MM-DD')
    // }
    delete this._resourceService.alert;
    this._resourceService.loading = true;
    let params = {
      date: formatedDate,
      doctorId: this.searchterms.doctorId,
      orgId: this.searchterms.departmentId,
      treatmentId: this.searchterms.treatmentId,
      payorId: this.searchterms.payorId,
      hour: this.searchterms.timeframeId,
      visitTypeId: this.searchterms.visitTypeId,
    };
    if (!this.searchterms.doctorId) {
      delete params.doctorId;
    }
    if (!this.searchterms.timeframeId) {
      delete params.hour;
    }
    if (!this.searchterms.treatmentId) {
      delete params.treatmentId;
    }
    if (!this.searchterms.visitTypeId) {
      delete params.visitTypeId;
    }
    this._resourceService.getResourceWithParams('freeslots', params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.freeslots = response.result;
        this.tableSlots = this._resourceService.convertToTableSlots(this.freeslots);
        this.firstDayReturned = Object.keys(this.tableSlots)[0];
        this.daySlots = this.tableSlots[this.firstDayReturned];
        this.firstDayReturnedShowed = moment(this.firstDayReturned).locale(this.translate.currentLang).format('LL');
        this.daySearchedtoCompare = moment(params.date).format('DD-MM-YYYY');
        this.daySearched = moment(params.date).locale(this.translate.currentLang).format('LL');
        this._resourceService.loading = false;
      } else {
        this._resourceService.manageErrorMessage(response.METADATA.ERROR_MESSAGE);
      }
    });
  }

  /** Antes de que el usuario confirme el hueco que ha seleccionado se le muestra la información y la guardamos en memoria */
  sendFreeslot(freeslot) {
    this._resourceService.selectedFreeslot = freeslot;
    this._resourceService.selectedFreeslot.payorName = this.selectedPayorName;
  }

  /** Si el usuario no quiere finalmente confirmar el hueco lo borramos de la memoria  */
  cancelSelectedfreeslot() {
    delete this._resourceService.selectedFreeslot;
  }

  /** Vaciamos los daySlots y lanzamos una nueva búsqueda con el siguiente día de los que estamos mostrando  */
  getPreviosDay() {
    this.daySlots = [];
    this.searchterms.date = moment(this.searchterms.date, 'DD/MM/YYYY').subtract(1, 'days').format('DD-MM-YYYY');
    //explorer 11 elimina la variable date del context no se porque y la almaceno aquí
    // this.explorerDateVariable = moment(this.firstDayReturned, 'YYYY/MM/DD').subtract(1, 'days').format('DD-MM-YYYY');
    let context = this;

    setTimeout(this.searchFreeSlots.bind(context), 400);
  }

  /** Vaciamos los daySlots y lanzamos una nueva búsqueda con el día anterior de los que estamos mostrando  */
  getNextDay() {
    this.daySlots = [];
    this.searchterms.date = moment(this.firstDayReturned, 'YYYY/MM/DD').add(1, 'days').format('DD-MM-YYYY');
    //explorer 11 elimina la variable date del context no se porque y la almaceno aquí
    // this.explorerDateVariable = moment(this.firstDayReturned, 'YYYY/MM/DD').add(1, 'days').format('DD-MM-YYYY');
    let context = this;
    setTimeout(this.searchFreeSlots.bind(context), 400);

  }

  /** Comprobamos si la reserva se hace para el propio paciente o para un dependiente, y si es para un dependiente comprobamos
   * que se haya elegido uno. Según sea para el usuario o un dependiente se envia a una función distinta
   */
  bookSlot(selectedFreeslot) {
    if (selectedFreeslot.payorName) {
      delete selectedFreeslot.payorName;
    }
    if (this.isForDependents) {
      if (!this.dependentId) {
        this.alert = "PLEASE_SELECT_DEPENDENT";
        $('#FreeSlotModal').animate({ scrollTop: 0 }, 'slow');
      } else {
        delete this.alert;
        $('#FreeSlotModal').modal('hide');
        this.bookDependentSlot(selectedFreeslot);
      }
    } else {
      $('#FreeSlotModal').modal('hide');
      this.bookPatientSlot(selectedFreeslot);
    }

  }

  /** Función que reserva un slot para el usuario. El back necesita un VisitType y como esta versión no lo incluye en todos sus 
   * formatos, de momento lo hardcodeamos. Luego mandamos los datos al back y si la respuesta es correcta vamos directamente al 
   * listado de citas del usuario. Si se ha creado un ppid pedimos los datos del usuario  (función que ya nos lleva al listado)
   *  y si ha dado error lo mostramos.
   */
  bookPatientSlot(selectedFreeslot) {
    // El back no reconoce el campo personalData y en caso de que exista lo eliminamos antes de enviarlo
    if (selectedFreeslot.doctor?.personalData) {
      delete selectedFreeslot.doctor.personalData;
    }
    window.scrollTo(0, 0);
    let params = {
      slot: selectedFreeslot,
      payorId: this.searchterms.payorId,
      patient: {
        patnr: this._userService.user.patnr,
        papid: this._userService.user.papid,
        email: this._userService.user.email,
      },
    };
    this._userService.doActionPatient('confirmappointment', params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
        this.router.navigate(['/user/myappointments']);
      } else if (response.METADATA.STATUS === AppConstants.STATUS.PAPID_CREATED) {
        this._userService.getData('');
      } else {
        // TODO que el back devuelva la clave en lugar de la string
        if (response.METADATA.ERROR_MESSAGE == 'You can have up to 2 appointments in the future.') {
          this._resourceService.alert = 'NO_MORE_TWO_APPOINTMENTS';
        } else {
          this._resourceService.manageErrorMessage(response.METADATA.ERROR_MESSAGE);
        }
        this._userService.loading = false;
      }
    }, err => {
      this._userService.checkError(err);
    });
    delete this._resourceService.selectedFreeslot;
  }

  /** Función que reserva un slot para un usuario dependiente del usuario. El back necesita un VisitType y como esta versión no lo incluye en todos sus
   * formatos, de momento lo hardcodeamos. Luego mandamos los datos al back y si la respuesta es correcta vamos directamente al
   * listado de citas del usuario. Si se ha creado un ppid pedimos los datos del usuario (función que ya nos lleva al listado)
   *  y si ha dado error lo mostramos.
   */
  bookDependentSlot(selectedFreeslot) {
    window.scrollTo(0, 0);
    let dependentId = this.dependentId
    let dependent = this._userService.user.dependents.filter(function (dependent) {
      return dependent.id === dependentId;
    })[0];
    let params = {
      slot: selectedFreeslot,
      payorId: this.searchterms.payorId,
      patient: {
        patnr: dependent.patnr,
        papid: dependent.papid,
        dependentId: dependent.id
      },
    };
    this._userService.doActionPatient('confirmappointment', params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
        this.router.navigate(['/user/myappointments']);
      } else if (response.METADATA.STATUS === AppConstants.STATUS.PAPID_CREATED) {
        let params = {
          dependentId: dependent.id
        }
        this._userService.getData(params);
      } else {
        this._resourceService.manageErrorMessage(response.METADATA.ERROR_MESSAGE);
      }
    });
    delete this._resourceService.selectedFreeslot;
  }

  /** Limpia todos los campos de búsqueda */
  reset() {
    this.searchterms = {
      hospitalId: null,
      payorId: null,
      departmentId: null,
      treatmentId: null,
      doctorId: null,
      date: this.tomorrow,
      timeframeId: null,
      visitTypeId: null,
      buildingUnitId: null
    };
    if (this._resourceService.payors.length == 1) {
      this.searchterms.payorId = this._resourceService.payors[0].id;
    }
    this.clearAlerts();
    delete this._resourceService.doctors;
    delete this._resourceService.treatments;
    delete this._databaseResourcesService.subdepartments;
  }

  /** Navega a la pestaña de registro */
  goRegister() {
    this.router.navigate(['/register']);
  }

  /** Recibe el id de un Hopital y pide a _resourceService los departamentos de ese hospital */
  getDepartments(hospitalId) {
    this.searchterms.treatmentId = null;
    this.searchterms.doctorId = null;
    delete this.daySlots
    this._resourceService.loading = true;
    let params = {
      hospitalId: hospitalId,
    };
    this._resourceService.getResourceWithParams('departments', params).subscribe(data => {
      let response = data as ResponseDataBase;
      this._resourceService.departments = response.result;
      this._resourceService.loading = false;
    });
  }

  /** Pide a _resourceService los médicos del departamento seleccionado en el combo */
  getConsultants() {
    delete this._resourceService.doctors;
    delete this._resourceService.alert;
    this.searchterms.doctorId = null;
    this._resourceService.loading = true;
    let params = {
      orgId: this.searchterms.departmentId,
      payorId: this.searchterms.payorId,
      treatmentId: this.searchterms.treatmentId,
      visitTypeId: this.searchterms.visitTypeId
    };
    if (!this.searchterms.treatmentId) {
      delete params.treatmentId;
    }
    if (!this.searchterms.visitTypeId) {
      delete params.visitTypeId;
    }
    if (!this.searchterms.departmentId) {
      delete params.orgId;
    }
    this._resourceService.getResourceWithParams('doctors', params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (!response.result.length) {
        this._resourceService.alert = 'NO_CONSULTANTS_IN_DEPARTMENT';
      }
      this._resourceService.doctors = response.result;
      this._resourceService.loading = false;
    });
  }

  /** Recibe el id de un departamento y coge de su objeto los tratamientos para mostralos en el combo */
  getTreatments(departmentlId) {
    let department = this._resourceService.departments.find(department => {
      return department.id === departmentlId
    })
    this._resourceService.treatments = department.treatments;
  }

  clearAlerts() {
    delete this._userService.danger;
    delete this._userService.warning;
    delete this._userService.success;
    delete this._resourceService.alert;
  }

  ngOnDestroy() {
    delete this._resourceService.alert;
  }

  ngOnInit() {
    if (!this._userService.user) {
      delete this.freeslots;
    }
    this._resourceService.justOnePayor.subscribe(
      (payors) => {
        this.searchterms.payorId = this._resourceService.payors[0].id;
      }
    );
  }

  ngAfterViewInit() {
    /** En caso de que tengamos seleccionado un slot y nos hayamos logueado u registrado desde su modal, volvemos a mostrarlo */
    setTimeout(() => {
      if (this._resourceService.selectedFreeslot) {
        $('#FreeSlotModal').modal('show');
      }
    });
  }

  ngDoCheck() {
    if (this.environmentName == 'typet' && !this._userService.user) {
      delete this.daySlots
    }
  }

  // Metodos de BBDD

  getDababaseDepartments(hospitalId) {
    this.searchterms.treatmentId = null;
    this.searchterms.doctorId = null;
    delete this.daySlots
    this._resourceService.loading = true;
    let params = {
      hospitalId: hospitalId,
    };
    this._databaseResourcesService.getDepartments(params).subscribe(data => {
      let response = data as ResponseDataBase;
      this._resourceService.departments = response.result;
      this._resourceService.loading = false;
    });
  }

  getSubdepartments(departmentlId) {
    let department = this._databaseResourcesService.departments.find(department => {
      return department.id === departmentlId
    })
    this._databaseResourcesService.subdepartments = department.subdepartments;
    this.searchterms.treatmentId = department.subdepartments[0];
    this.getDababaseConsultants();
  }

  getDababaseConsultants() {
    delete this._resourceService.alert;
    this._resourceService.loading = true;
    let params = {
      departmentId: this.searchterms.departmentId.id,
      subdepartmentId: this.searchterms.treatmentId.id,
    }
    this._databaseResourcesService.getConsultantsFromUnit(params).subscribe(data => {
      let response = data as ResponseDataBase;
      this._resourceService.doctors = response.result;
      this._resourceService.loading = false;
    });
  }

  /** Recibe el id de un departamento y coge de su objeto los tratamientos para mostralos en el combo */
  getDababaseSubdepartments(unit) {
    let params = {
      departmentId: unit.id,
    };
    this._databaseResourcesService.getSubdepartments(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this._databaseResourcesService.subdepartments = response.result;
        this._resourceService.loading = false;
      });
  }

  searchDatabaseFreeSlots() {
    let formatedDate;
    formatedDate = moment(this.searchterms.date, "DD-MM-YYYY").format('YYYY-MM-DD');
    delete this._resourceService.alert;
    this._resourceService.loading = true;
    delete this.daySlots;
    let params = {
      date: formatedDate,
      departmentId: this.searchterms.departmentId.id,
      subdepartmentId: this.searchterms.treatmentId.id,
      consultantId: ''
    };
    if (this.searchterms.doctorId) {
      params.consultantId = this.searchterms.doctorId;
    }
    this._databaseResourcesService.searchDatabaseFreeSlots(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.freeslots = response.result;
        this.tableSlots = this._resourceService.convertToTableSlots(this.freeslots);
        this.firstDayReturned = Object.keys(this.tableSlots)[0];
        this.daySlots = this.tableSlots[this.firstDayReturned];
        this.firstDayReturnedShowed = moment(this.firstDayReturned).locale(this.translate.currentLang).format('LL');
        this.daySearchedtoCompare = moment(params.date).format('DD-MM-YYYY');
        this.daySearched = moment(params.date).locale(this.translate.currentLang).format('LL');
        this._resourceService.loading = false;
      } else {
        this._resourceService.manageErrorMessage(response.METADATA.ERROR_MESSAGE);
      }
    });
  }

  bookDatabaseSlot(selectedFreeslot) {
    window.scrollTo(0, 0);
    delete selectedFreeslot.department.passedByConsultant;
    delete selectedFreeslot.department.subdepartments;
    delete selectedFreeslot.treatment.passedByConsultant;
    this._userService.bookDatabaseSlot(selectedFreeslot).subscribe(data => {
      let response = data as ResponseDataBase;
      $('#FreeSlotModal').modal('hide');
      if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
        this.router.navigate(['/user/myappointments']);
      } else {
        this._resourceService.manageErrorMessage(response.METADATA.ERROR_MESSAGE);
        this._userService.loading = false;
      }
    });
    delete this._resourceService.selectedFreeslot;

  }


}
